import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "classes", "view"];
import React, { forwardRef } from 'react';
import classNames from 'classnames/bind';
import { TextBase } from '../../TextBase';
import styles from './ListItem.css';
var cx = classNames.bind(styles);
export var ListItem = /*#__PURE__*/forwardRef(function ListItem(_ref, ref) {
  var children = _ref.children,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      _ref$view = _ref.view,
      view = _ref$view === void 0 ? 'desktop' : _ref$view,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    React.createElement(TextBase, _extends({}, props, {
      as: "li",
      size: "m",
      color: "N900",
      ref: ref,
      classes: {
        root: cx('root', "view_".concat(view), classes === null || classes === void 0 ? void 0 : classes.root)
      },
      display: "flex",
      noWrap: true
    }), children)
  );
});